// DO NOT EDIT THIS FILE, EDIT THE WEBPACK COMMON CONFIG INSTEAD, WHICH WILL MODIFY THIS FILE
declare const __VERSION__: string;
export const VERSION = __VERSION__;
declare const __DEBUG_INFO_ENABLED__: boolean;
export const DEBUG_INFO_ENABLED = __DEBUG_INFO_ENABLED__;
declare const __IS_DEV__: boolean;
export const IS_DEV = __IS_DEV__;
declare const __IS_DEV_USING_STAGING_BACKEND__: boolean;
export const IS_DEV_USING_STAGING_BACKEND = __IS_DEV_USING_STAGING_BACKEND__;



// WEBPACK FOOTER //
// ./src/app/app.constants.ts